<div class="content p-3">
  <h1>{{dialogData.title}}</h1>
  <p>{{dialogData.content}}</p>
  <div class="columns mt-3 is-justify-content-center">
    <div class="column is-6 text-center">
      <a class="button back-button has-round-border" (click)="closeDialog()">
        <div class="column is-bold">
          <p>{{dialogData.buttonText}}</p>
        </div>
      </a>
    </div>
  </div>
</div>
